const makeJCFServerCommonChecks = () => {
  if (window.JCFServerCommon === undefined) {
    window.JCFServerCommon = {
      frames: {},
      func: {}
    };
  }
};

export default makeJCFServerCommonChecks;
